import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import { setError } from '../common/toast/toast';
import imagemAdd from '../assets/images/icone_add_imagem.png';
import pdfAdd from '../assets/images/icone_add_pdf.png';
import readXlsxFile from 'read-excel-file/web-worker'
import {
	setModoTela, initForm, gerarPdf
} from './certificadoEmissaoActions';
import FormatUtils from '../common/formatUtils/FormatUtils';
import CertificadoModeloFolha from '../certificadoModelo/certificadoModeloFolha';
import DateFormat from '../common/dateFormat/DateFormat';

class CertificadoEmissaoForm extends Component {

	state = {
	}

    componentWillMount() {

		let initSeletorExcel = () => {
			const fileSelectorExcel = document.createElement('input');
			fileSelectorExcel.setAttribute('type', 'file');
			fileSelectorExcel.addEventListener('change', async (data) => {

				let reader = new FileReader();
				let file = data && data.path && data.path[0] && data.path[0].files && data.path[0].files[0] ? data.path[0].files[0] : null;
				if (!file) {
					file = data && data.target && data.target.files && data.target.files[0] ? data.target.files[0] : null;
				}

				if (file) {

					if (!file.type.includes('text/csv')) {
						setError('Selecione apenas (.CSV)');
						return;
					}

					reader.onload = () => {
    					const linhas = reader.result.split('\n');

						let lista = [];
						for (let i = 1; i < linhas.map(linha => linha.split(',')).length; i++) {
							const item = linhas.map(linha => linha.split(','))[i];
							
							lista.push({
								plataforma: (item[0] || '').replace(/^"|"$/g, '').replace(/\\"/g, '"'),
								aluno: (item[1] || '').replace(/^"|"$/g, '').replace(/\\"/g, '"'),
								email: (item[2] || '').replace(/^"|"$/g, '').replace(/\\"/g, '"'),
								telefone: (item[3] || '').replace(/^"|"$/g, '').replace(/\\"/g, '"'),
								curso: (item[4] || '').replace(/^"|"$/g, '').replace(/\\"/g, '"'),
								data_emissao: DateFormat.formatarDataTelaParaSql(item[5])
							});
						}

						this.props.initForm({
							...this.props.formularioValues,
							listaKeplerFlix: lista
						});
					};

					reader.readAsText(file);

				}
			});

			this.fileSelectorExcel = fileSelectorExcel;

		}

		initSeletorExcel();

		let initSeletorImagemAssinaturaAluno = () => {
			const fileSelectorImagemAssinaturaAluno = document.createElement('input');
			fileSelectorImagemAssinaturaAluno.setAttribute('type', 'file');
			fileSelectorImagemAssinaturaAluno.addEventListener('change', (data) => {

				let reader = new FileReader();
				let file = data && data.path && data.path[0] && data.path[0].files && data.path[0].files[0] ? data.path[0].files[0] : null;
				if (!file) {
					file = data && data.target && data.target.files && data.target.files[0] ? data.target.files[0] : null;
				}

				if (file) {				

					if (!file.type.includes('image/png') && !file.type.includes('image/jpg') && !file.type.includes('image/jpeg')) {
						setError('Selecione apenas (.PNG, .JPG e .JPEG)');
						return;
					}

					reader.onloadend = () => {

						this.props.initForm({
							...this.props.formularioValues,
							assinatura_aluno: reader.result
						});

						initSeletorImagemAssinaturaAluno();

					}

					reader.readAsDataURL(file);

				}
			});

			this.fileSelectorImagemAssinaturaAluno = fileSelectorImagemAssinaturaAluno;

		}

		initSeletorImagemAssinaturaAluno();

		let initSeletorImagemAssinaturaInstrutor = () => {
			const fileSelectorImagemAssinaturaInstrutor = document.createElement('input');
			fileSelectorImagemAssinaturaInstrutor.setAttribute('type', 'file');
			fileSelectorImagemAssinaturaInstrutor.addEventListener('change', (data) => {

				let reader = new FileReader();
				let file = data && data.path && data.path[0] && data.path[0].files && data.path[0].files[0] ? data.path[0].files[0] : null;
				if (!file) {
					file = data && data.target && data.target.files && data.target.files[0] ? data.target.files[0] : null;
				}

				if (file) {				

					if (!file.type.includes('image/png') && !file.type.includes('image/jpg') && !file.type.includes('image/jpeg')) {
						setError('Selecione apenas (.PNG, .JPG e .JPEG)');
						return;
					}

					reader.onloadend = () => {

						this.props.initForm({
							...this.props.formularioValues,
							assinatura_instrutor: reader.result
						});

						initSeletorImagemAssinaturaInstrutor();

					}

					reader.readAsDataURL(file);

				}
			});

			this.fileSelectorImagemAssinaturaInstrutor = fileSelectorImagemAssinaturaInstrutor;

		}

		initSeletorImagemAssinaturaInstrutor();
    }

    render() {

		let readOnly = this.props.endereco || this.props.excluir ? 'readOnly' : '';

		const registroModelo = this.props.listaModelo.filter(item => item.id == this.props.formularioValues.id_modelo)[0];

		const tipoChecklistKepler = this.props.formularioValues.id_origem == 1;
		const tipoKeplerFlix = this.props.formularioValues.id_origem == 2;
		const tipoAvulso = this.props.formularioValues.id_origem == 3;
		
		return (
			<>
				{!this.props.formularioValues.id &&
				<ContentCard>
					<Form event={this.props.handleSubmit}>
						<ContentCardBody>
							<Row>
								
								{(tipoChecklistKepler || tipoAvulso) && //Checklist Kepler
								<Field
									name='id_checklist_resposta'
									component={Select}
									options={this.props.listaChecklistResposta}
									label='Checklist'
									cols='12 12 12 12'
									placeholder='Selecione'
									readOnly={readOnly} />}
								
								{tipoKeplerFlix && //KeplerFlix
								<Grid cols='12 12 12 12'>
									<Row style={{ paddingBottom: 16 }}>
										<Grid cols='12 12 12 12'>
											<label>CSV KeplerFlix</label>
										</Grid>
										{this.props.formularioValues.listaKeplerFlix ? (
											<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginLeft: 10 }}>
												<a class='btn btn-app bg-success'>
													<span class='badge bg-purple'>{this.props.formularioValues.listaKeplerFlix.length}</span>
													<i class='fas fa-file-excel'></i> Importado
												</a>
												<button
													type='button'
													class='btn btn-flat btn-outline-danger'
													style={{ width: 40, height: 40 }}
													disabled={readOnly}
													onClick={() => {
														this.props.initForm({
															...this.props.formularioValues,
															listaKeplerFlix: null
														});
													}}>
													<i class='fas fa-trash-alt'></i>
												</button>
											</div>
										) : (
											<span class='btn btn-outline-primary fileinput-button dz-clickable'
												style={{ marginLeft: 10 }}
												onClick={() => this.fileSelectorExcel.click()}>
												<img src={pdfAdd} style={{ height: 40 }} />
											</span>
										)}
									</Row>
								</Grid>}

								<Field
									name='id_modelo'
									component={Select}
									options={this.props.listaModelo}
									label='Modelo'
									cols='12 12 12 12'
									placeholder='Selecione'
									readOnly={readOnly} />									
								
								{tipoAvulso &&
								<Field
									name='nome_aluno'
									component={LabelAndInput}
									label='Nome do Aluno' placeholder='Informe'
									cols='12 12 12 12'
									readOnly={readOnly} />}

								{tipoAvulso &&
								<Grid cols='12 12 12 12'>
									<Row style={{ paddingBottom: 16 }}>
										<Grid cols='12 12 12 12'>
											<label>Imagem Assinatura Aluno</label>
										</Grid>
										{this.props.formularioValues.assinatura_aluno ? (
											<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginLeft: 10 }}>
												<span class='btn btn-outline-primary fileinput-button dz-clickable'>
													<img src={this.props.formularioValues.assinatura_aluno} style={{ height: 40 }} />
												</span>
												<button
													type='button'
													class='btn btn-flat btn-outline-danger'
													style={{ width: 40, height: 40 }}
													disabled={readOnly}
													onClick={() => {
														this.props.initForm({
															...this.props.formularioValues,
															assinatura_aluno: null
														});
													}}>
													<i class='fas fa-trash-alt'></i>
												</button>
											</div>
										) : (
											<span class='btn btn-outline-primary fileinput-button dz-clickable'
												style={{ marginLeft: 10 }}
												onClick={() => this.fileSelectorImagemAssinaturaAluno.click()}>
												<img src={pdfAdd} style={{ height: 40 }} />
											</span>
										)}
									</Row>
								</Grid>}

								<Field
									name='nome_instrutor'
									component={LabelAndInput}
									label='Nome do Instrutor' placeholder='Informe'
									cols='12 12 12 12'
									readOnly={readOnly} />

								<Grid cols='12 12 12 12'>
									<Row style={{ paddingBottom: 16 }}>
										<Grid cols='12 12 12 12'>
											<label>Imagem Assinatura Instrutor</label>
										</Grid>
										{this.props.formularioValues.assinatura_instrutor ? (
											<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginLeft: 10 }}>
												<span class='btn btn-outline-primary fileinput-button dz-clickable'>
													<img src={this.props.formularioValues.assinatura_instrutor} style={{ height: 40 }} />
												</span>
												<button
													type='button'
													class='btn btn-flat btn-outline-danger'
													style={{ width: 40, height: 40 }}
													disabled={readOnly}
													onClick={() => {
														this.props.initForm({
															...this.props.formularioValues,
															assinatura_instrutor: null
														});
													}}>
													<i class='fas fa-trash-alt'></i>
												</button>
											</div>
										) : (
											<span class='btn btn-outline-primary fileinput-button dz-clickable'
												style={{ marginLeft: 10 }}
												onClick={() => this.fileSelectorImagemAssinaturaInstrutor.click()}>
												<img src={pdfAdd} style={{ height: 40 }} />
											</span>
										)}
									</Row>
								</Grid>
							</Row>
						</ContentCardBody>
						<ContentCardFooter>
							<Row alignCenter>
								<Grid cols='6 6 4 3'>
									{this.props.excluir ? (
										<Button
											text='Excluir'
											submit type={'danger'}
											icon={'fa fa-trash'} />
									) : (
										<Button
											text='Gerar'
											submit
											type={'success'}
											icon={'fa fa-check'} />
									)}
								</Grid>
								<Grid cols='6 6 4 3'>
									<Button
										text='Voltar'
										type={'warning'}
										icon={'fa fa-chevron-left'}
										event={() => window.confirm('Deseja realmente sair dessa tela?') ? this.props.setModoTela('lista') : null} />
								</Grid>
							</Row>
						</ContentCardFooter>
					</Form>
				</ContentCard>}

				{(registroModelo && this.props.formularioValues.id) &&
				<ContentCardFooter>
					<Row alignCenter>
						<Grid cols='6 6 4 3'>
							<Button
								text='Imprimir'
								type={'primary'}
								icon={'fa fa-chevron-left'}
								event={() => this.props.gerarPdf(this.props.formularioValues)} />
						</Grid>
						<Grid cols='6 6 4 3'>
							<Button
								text='Voltar'
								type={'warning'}
								icon={'fa fa-chevron-left'}
								event={() => this.props.setModoTela('lista')} />
						</Grid>
					</Row>
				</ContentCardFooter>}

				{registroModelo &&
					<CertificadoModeloFolha 
						registro={{ 
							...registroModelo,
							nome_aluno: this.props.formularioValues.nome_aluno,
							assinatura_aluno: this.props.formularioValues.assinatura_aluno,
							nome_instrutor: this.props.formularioValues.nome_instrutor,
							assinatura_instrutor: this.props.formularioValues.assinatura_instrutor,
							nome_cliente: this.props.formularioValues.nome_cliente,
							curso: this.props.formularioValues.curso,
							carga_horaria: this.props.formularioValues.carga_horaria,
							data_emissao: this.props.formularioValues.data_emissao,
							data_inicio: this.props.formularioValues.data_inicio,
							data_fim: this.props.formularioValues.data_fim,
							modulos: this.props.formularioValues.modulos,
							QRCode: this.props.QRCode
						}} />}
			</>
		);
    }


}

CertificadoEmissaoForm = reduxForm({form: 'certificadoEmissaoForm', destroyOnUnmount: false})(CertificadoEmissaoForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('certificadoEmissaoForm')(state),
	registro: state.certificadoEmissao.registro,
	listaChecklistResposta: state.certificadoEmissao.listaChecklistResposta,
	listaModelo: state.certificadoEmissao.listaModelo,
	QRCode: state.certificadoEmissao.QRCode
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm, gerarPdf
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(CertificadoEmissaoForm);
